import {DefaultLanguage, Locale} from "../";

export const Route = (path: string) => {
    const locale = Locale.getLang();
    if (locale === DefaultLanguage)
        return Locale.format(path);
    else
        return `/${locale}` + Locale.format(path);
};
